import React, { FC, useEffect, useMemo, useState } from 'react'
import Lightbox from 'react-image-lightbox'
import 'react-image-lightbox/style.css'
import TrashIcon from '../../../components/UI/Icons/Trash'
import { MEDIA_DATA_TYPE } from '../../../models/post'
import CanvaButton, { TCanvaPayload } from '../../PostCreation/CanvaButton/CanvaButton'

interface ModalProps {
  index: number
  images: MEDIA_DATA_TYPE[]
  onClose: () => void
  onRemove: (index: number) => void
  onUpdateCanvaImage?: (payload: TCanvaPayload) => void
  isEditable: boolean
}

const Modal: FC<ModalProps> = ({
  images,
  isEditable,
  index,
  onClose,
  onRemove,
  onUpdateCanvaImage
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState<number>(index)

  const onMovePrevRequest = () =>
    setCurrentImageIndex((currentImageIndex + images.length - 1) % images.length)

  const onMoveNextRequest = () => setCurrentImageIndex((currentImageIndex + 1) % images.length)

  useEffect(() => {
    setCurrentImageIndex(index)
  }, [index])

  const removeButton = useMemo(() => {
    const button = React.createElement(
      'div',
      {
        className: 'image-actions_remove',
        onClick: () => onRemove(currentImageIndex)
      },
      <TrashIcon />
    )
    return isEditable ? button : null
  }, [onRemove, currentImageIndex])

  const canvaButton = useMemo(() => {
    if (images[currentImageIndex]) {
      const designId = images[currentImageIndex].canva_design_id
      if (designId && isEditable && onUpdateCanvaImage) {
        const button = React.createElement(
          'div',
          {
            className: 'image-actions_canva-edit'
          },
          <CanvaButton designId={designId} updateImageData={onUpdateCanvaImage} />
        )
        return button
      }
      return <></>
    }
  }, [onRemove, currentImageIndex])

  return (
    <>
      {images[currentImageIndex] && (
        <Lightbox
          toolbarButtons={[removeButton, canvaButton]}
          mainSrc={images[currentImageIndex].public_url}
          nextSrc={images[(currentImageIndex + 1) % images.length].public_url}
          prevSrc={images[(currentImageIndex + images.length - 1) % images.length].public_url}
          onCloseRequest={onClose}
          onMovePrevRequest={onMovePrevRequest}
          onMoveNextRequest={onMoveNextRequest}
          wrapperClassName={images.length === 1 ? 'controls-invisible' : ''}
        />
      )}
    </>
  )
}

export default Modal
